import React from 'react';
import UserFormTextInput from './UserFormTextInput';
import {Atom} from '@packages/systems/wfdl';
import {appendUserInputClasses} from '@packages/systems/users/utils/universalUtils';
import {USYS_DATA_ATTRS} from '@packages/systems/users/constants';
import {WebflowEnvironments} from '@packages/systems/core-constants';
import {useRuntimeEnvironment} from '@packages/systems/render';
import {getInPojo, getString} from '@packages/utilities/data-utils';

const {DESIGNER} = WebflowEnvironments;

// Mostly a clone of UserFormTextInput, but it has to have a different render
// component in order to show a number mock value in the Designer
const UserFormNumberInput = Atom.createRender(
  ({attributes, classes, generateAttributes, context, data}) => {
    const inputClasses = appendUserInputClasses(data, classes);
    const field = getString(getInPojo(data, ['users', 'field']));
    const fieldType = getString(getInPojo(data, ['users', 'fieldType']));
    const runtimeEnvironment = useRuntimeEnvironment();
    const mockValue = context.get('data')?.mockCustomNumberField;

    // Set mock user name as value for user account page
    if (runtimeEnvironment === DESIGNER && mockValue)
      attributes = attributes.set('value', mockValue);

    const attributeWithField = field
      ? attributes.set(USYS_DATA_ATTRS.field, field)
      : attributes;

    return (
      <input
        {...generateAttributes(
          fieldType
            ? attributeWithField.set(USYS_DATA_ATTRS.fieldType, fieldType)
            : attributeWithField,
          inputClasses
        )}
      />
    );
  }
);

const config = Atom.create({
  ...Atom.getConfigShape(UserFormTextInput),
  displayName: 'Number Field',
  render: UserFormNumberInput,
});

export default config;
